// import logo from './logo.svg';
// import './App.css';
import { Route, Routes } from 'react-router-dom'

import Dashboard from './components/Dashboard/Dasboard.js'
import ErrorPage from './components/ErrorPage/ErrorPage.js';
import Form from './components/Form/Form';
import Login from './components/Login/Login.js'
import Movies from './components/Movies/Movies.js'
import Navbar from './components/Navbar/Navbar';
import Privacity from './components/Privacity/Privacity.js';
import Series from './components/Series/Series.js'
import SignIn from './components/SignIn/SignIn.js'
import TermAndCond from './components/TermAndCond/TermAndCond.js';


function App() {

  return (
    <div className="fl-cl App">
      <Navbar></Navbar>
      <Routes >
        <Route path='/signin' element={<SignIn />}></Route>
        <Route path='/series' element={<Series />}></Route>
        <Route path='/dashboard/form/:id' element={<Form />}></Route>
        <Route path='/dashboard/form' element={<Form />}></Route>
        <Route path='/dashboard/:selected' element={<Dashboard />}></Route>
        <Route path='/dashboard' element={<Dashboard />}></Route>
        <Route path='/login' element={<Login />}></Route>
        <Route path='/terms' element={<TermAndCond />}></Route>
        <Route path='/privacity' element={<Privacity />} ></Route>
        <Route path='/' element={<Movies />}></Route>
        <Route path='*' element={<ErrorPage/>}></Route>
      </Routes>
    </div>
  );
}

export default App;
